import apiService from "./apiService"

const ratingApiSlice = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchAppointmentsRatingStatus: builder.query({
      query: (params) => ({ url: "ratings/appointmentstatus", params: params }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    fetchRatingDetails: builder.query({
      query: (id) => ({ url: `ratings/details/${id}` }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    updateRating: builder.mutation({
      query: ({ id, rating }) => ({
        url: `ratings/rate/${id}`,
        body: { rating },
        method: "POST",
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    closeLink: builder.mutation({
      query: ({ id }) => ({
        url: `ratings/close/${id}`,
        method: "POST",
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    addReviewWithRating: builder.mutation({
      query: ({ id, review }) => ({
        url: `review/${id}`,
        body: { review },
        method: "POST",
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
})

export default ratingApiSlice

export const {
  useLazyFetchAppointmentsRatingStatusQuery,
  useLazyFetchRatingDetailsQuery,
  useUpdateRatingMutation,
  useCloseLinkMutation,
  useAddReviewWithRatingMutation,
} = ratingApiSlice
